var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breakpoint=='xs')?_c('IndexCompact',{attrs:{"customers":_vm.customers,"moc":_vm.moc}}):_c('IndexNormal',{attrs:{"customers":_vm.customers,"moc":_vm.moc}})
}
var staticRenderFns = []

export { render, staticRenderFns }